import { render } from "./BasketBallFenxi.vue?vue&type=template&id=5fc93dc6&scoped=true&ts=true"
import script from "./BasketBallFenxi.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasketBallFenxi.vue?vue&type=script&setup=true&lang=ts"

import "./BasketBallFenxi.vue?vue&type=style&index=0&id=5fc93dc6&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc93dc6"],['__file',"src/components/player/BasketBallFenxi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fc93dc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fc93dc6', __exports__)) {
    console.log('reload')
    api.reload('5fc93dc6', __exports__)
  }
  
  module.hot.accept("./BasketBallFenxi.vue?vue&type=template&id=5fc93dc6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5fc93dc6', render)
  })

}


export default __exports__